
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/recover-password",
      function () {
        return require("private-next-pages/login/recover-password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/recover-password"])
      });
    }
  